import React, { useState, useRef } from 'react';

function InputColor({ label, name, id, defaultValue, err, handleChange, disabled, required }) {
  const [color, setColor] = useState( defaultValue ?? '#000000'); // Initial color value

  const colorInputRef = useRef(null);

  const handleColorChange = (e) => {
    setColor(e.target.value);
    handleChange(e)
  };

  const toggleColorInput = () => {
    if (colorInputRef.current) {
      colorInputRef.current.click();
    }
  };

  return (
    <div className="relative">
      <label htmlFor={ name } className="block text-sm font-medium leading-6 text-gray-900">
        { label }{required ? "*" : ""}
      </label>
      <input
        type="color"
        value={color}
        name={name}
        id={ id }
        onChange={handleColorChange}
        ref={colorInputRef}
        className="absolute top-0 left-0 opacity-0"
        disabled={disabled}
      />
      <div
        className="w-10 h-10 bg-white p-2 rounded-md shadow-md cursor-pointer" onClick={ toggleColorInput }
      >
        <div
          className="w-6 h-6 rounded-full cursor-pointer"
          style={{ backgroundColor: color }}
        ></div>
      </div>
      {
        err && <p className="mt-2 text-sm text-red-600">
        { err }
      </p>
      }
    </div>
  );
}

export default InputColor;
